var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0898 0 32 2.91015 32 6.5V25.5C32 29.0898 29.0898 32 25.5 32H6.5C2.91015 32 0 29.0898 0 25.5V6.5Z",
    fill: "#00BDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.063 9.61599H7.85103C6.85691 9.61599 6.05103 8.8101 6.05103 7.81599C6.05103 6.82188 6.85691 6.01599 7.85103 6.01599H21.063C22.0571 6.01599 22.863 6.82188 22.863 7.81599C22.863 8.8101 22.0571 9.61599 21.063 9.61599Z",
    fill: "url(#paint0_linear_555:1472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.163 15H10.951C10.3079 15 9.71369 14.6569 9.39216 14.1C9.07062 13.5431 9.07062 12.8569 9.39216 12.3C9.71369 11.7431 10.3079 11.4 10.951 11.4H24.163C25.1571 11.4 25.963 12.2059 25.963 13.2C25.963 14.1941 25.1571 15 24.163 15Z",
    fill: "url(#paint1_linear_555:1472)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.063 20.616H7.85103C6.85691 20.616 6.05103 19.8101 6.05103 18.816C6.05103 17.8219 6.85691 17.016 7.85103 17.016H21.063C22.0571 17.016 22.863 17.8219 22.863 18.816C22.863 19.8101 22.0571 20.616 21.063 20.616Z",
    fill: "url(#paint2_linear_555:1472)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.163 26H10.951C9.95689 26 9.151 25.1941 9.151 24.2C9.151 23.2059 9.95689 22.4 10.951 22.4H24.163C25.1571 22.4 25.963 23.2059 25.963 24.2C25.963 25.1941 25.1571 26 24.163 26Z",
    fill: "url(#paint3_linear_555:1472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_555:1472",
    x1: 6.05103,
    y1: 9.61599,
    x2: 22.863,
    y2: 9.61599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_555:1472",
    x1: 9.151,
    y1: 15,
    x2: 25.963,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_555:1472",
    x1: 6.05103,
    y1: 20.616,
    x2: 22.863,
    y2: 20.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_555:1472",
    x1: 9.151,
    y1: 26,
    x2: 25.963,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanner);
export default __webpack_public_path__ + "static/media/IconPlanner.dbb94427057cf9221cac16bb9e241051.svg";
export { ForwardRef as ReactComponent };